import React from 'react';

import Location from './Location';
import { Link } from 'react-router-dom';

const Locations = props => {
    var rendered = [];
    /*
        "locationID": "887",
        "locationName": "TVW",
        "locationDescription": "For testing location management",
        "locationContact": "Adam",
        "locationAddress": "1058 Capitol Way S, Olympia, WA 98501",
        "locationPhone": "555-3534"
        */
    for (var i = 0; i < props.locations.length; i++) {
        var location = props.locations[i];
        if (location['locationName'].toLowerCase().indexOf(props.term) >= 0) {
            var push = true
            if (props.mode == 'event' && props.assigned == location.locationName) push = false;
            if (push) {
                var actions = props.actions;
                rendered.push(
                    <Location {...props}
                        key={'location-' + location.locationID + '-' + props.mode + '-' + i}
                        assignLocationToEvent={props.mode == 'event' ? props.assignLocationToEvent.bind(null, i) : null}
                        actions={actions}
                        location={location}/>
                );
            }
        }
    }

    if (!rendered.length) {
        return <div className="alert alert-warning">
            <p><strong><i>No Assignable Locations</i></strong></p>
            <p><Link href="/manage/locations">Create and Manage them here &hellip;</Link></p>
        </div>;
    }  else {
        return <div>{rendered}</div>;
    }
}


export default Locations;
